/**
 * 将 axios 错误转成用户可读文案（含 502 网关场景）
 */
function isHtmlBody(data) {
  if (typeof data !== 'string') return false
  const s = data.trim()
  return s.startsWith('<!DOCTYPE') || s.startsWith('<html') || /<\/html>/i.test(s)
}

function extractPreText(html) {
  if (typeof html !== 'string') return ''
  const m = html.match(/<pre[^>]*>([\s\S]*?)<\/pre>/i)
  return m && m[1] ? String(m[1]).trim() : ''
}

export function formatApiError(err, fallback = '请求失败') {
  const status = err && err.response && err.response.status
  const data = err && err.response && err.response.data

  if (status === 404) {
    const pre = isHtmlBody(data) ? extractPreText(data) : ''
    if (pre && /Cannot (GET|POST|PUT|DELETE)/i.test(pre)) {
      return `接口未部署（404）：${pre}。请将 backend 最新代码上传到服务器并执行 pm2 restart eating-api`
    }
    return '接口不存在（404），请确认后端已更新并重启 Node 服务'
  }

  if (isHtmlBody(data)) {
    const pre = extractPreText(data)
    if (pre) return pre
    return fallback
  }

  // 先优先展示后端返回的明确 message，避免把“MySQL down/鉴权失败”误判成“网关问题”
  if (data && typeof data === 'object' && data.message) return String(data.message)
  if (typeof data === 'string' && data.length && data.length < 300 && !isHtmlBody(data)) {
    return String(data)
  }

  if (status === 401) return '登录已失效，请重新登录后台'
  if (status === 403) return '无权限执行此操作'

  if (status === 502 || status === 504) {
    return `网关错误 ${status}：网页能打开，但 Nginx 连不上 Node 后端。请在服务器检查：① pm2 status / 进程是否运行 ② Nginx 里 proxy_pass 的端口是否与后端 PORT 一致（常见 3000 与 3001 写错）③ 浏览器访问 ${typeof window !== 'undefined' ? window.location.origin : ''}/api/health 是否返回 JSON`
  }
  if (status === 503) {
    if (data && typeof data === 'object' && data.message) return String(data.message)
    return (
      '服务不可用（503）：请检查后端已启动、以及 MySQL/表是否就绪。' +
      (typeof window !== 'undefined' ? `你也可以访问 ${window.location.origin}/api/health 查看 MySQL 状态。` : '')
    )
  }
  if (err && err._networkHint) return err._networkHint
  return fallback
}
